import React from 'react';
import { SalesPage } from './components/SalesPage';
export function App() {
  return <div className="w-full min-h-screen bg-cream-50" data-id="element-0">
      <SalesPage data-id="element-1" />
    </div>;
}